import {
  SecuritySettingsSsoEnforcementEnum,
  UpdateSsoEnforcementDocument,
} from 'generated/resources/graphql'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'

export function useUpdateSsoEnforcement() {
  const session = useCurrentSession()
  const [mutation, { loading }] = useMutation(UpdateSsoEnforcementDocument, {
    extractorFn: (data) => data.securitySettingsMutations.updateSecuritysettingsCompanyConfig,
  })

  const updateSsoEnforcement = useUnsafeCallback(
    (ssoEnforcement: SecuritySettingsSsoEnforcementEnum) => {
      return mutation({
        variables: {
          companyId: session.company.id,
          ssoEnforcement: ssoEnforcement,
        },
      })
    },
    [mutation, session.company.id]
  )

  return {
    updateSsoEnforcement,
    loading,
  }
}
